"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M1.25 8a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0zM8 .25a7.75 7.75 0 100 15.5A7.75 7.75 0 008 .25zm3.61 6a.5.5 0 00-.74-.67L7.33 9.53 5.66 7.76a.5.5 0 10-.73.68l2.05 2.18a.5.5 0 00.74-.01l3.9-4.36z"
}));

exports["default"] = _default;